import { Action } from "@ngrx/store";

export const GET_IMPORT_LIST = '[Import ] Get Import List';
export const GET_IMPORT_LIST_SUCCESS = '[Import ] Get Import List Success';
export const GET_IMPORT_LIST_FAIL = '[Import ] Get Import List Fail';
export const CLEAR_IMPORT_LIST = '[Import ] Clear Import List';
export const RESET_IMPORT_CRUD = '[Import] Reset CRUD';

export const ADD_IMPORT_JOB = '[Import] Add Job Request';
export const ADD_IMPORT_JOB_SUCCESS = '[Import] Add Job Request Success';
export const ADD_IMPORT_JOB_FAIL = '[Import] Add Job Request Fail';

export class GetImportList implements Action {
  readonly type = GET_IMPORT_LIST;
  constructor(public payload: any = null) { }
}

export class GetImportListSuccess implements Action {
  readonly type = GET_IMPORT_LIST_SUCCESS;
  constructor(public payload: any = null) { }
}

export class GetImportListFail implements Action {
  readonly type = GET_IMPORT_LIST_FAIL;
  constructor(public payload: any = null) { }
}

export class ClearImportList implements Action {
  readonly type = CLEAR_IMPORT_LIST;
  constructor(public payload: any = null) { }
}

export class ResetImportCRUD implements Action {
  readonly type = RESET_IMPORT_CRUD;
  constructor(public payload: any = null) { }
}

export class AddImportJob implements Action {
  readonly type = ADD_IMPORT_JOB;
  constructor(public payload: any) { }
}

export class AddImportJobSuccess implements Action {
  readonly type = ADD_IMPORT_JOB_SUCCESS;
  constructor(public payload: any = null) { }
}

export class AddImportJobFail implements Action {
  readonly type = ADD_IMPORT_JOB_FAIL;
  constructor(public payload: any = null) { }
}

export type ImportActions =
  | GetImportList
  | GetImportListSuccess
  | GetImportListFail
  | ClearImportList
  | AddImportJob
  | AddImportJobSuccess
  | AddImportJobFail
  | ResetImportCRUD;